import React, { useEffect, useState } from "react";
import app from "../util/firebase";
import {
  getDatabase,
  ref,
  set,
  update,
  push,
  orderByChild,
  equalTo,
  query,
  remove,
  onValue,
} from "firebase/database";
// eslint-disable-next-line
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";

// eslint-disable-next-line
import relativeTime from "dayjs/plugin/relativeTime";
import { makeStyles } from "@mui/styles";
import { useTheme } from "@mui/material/styles";
import DeleteIcon from "@mui/icons-material/Delete";
import PropTypes from "prop-types";
import { Progress } from "./progress";
import { Card, CircularProgress } from "@mui/material";

function CircularProgressWithLabel(props) {
  return (
    <Card sx={{ position: "relative", display: "inline-flex" }}>
      <CircularProgress variant="determinate" {...props} />
      <Box
        sx={{
          top: 0,
          left: 0,
          //   bottom: 0,
          //   right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="caption" component="div" color="text.secondary">
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Card>
  );
}

CircularProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: PropTypes.number.isRequired,
};

export default function Monitor() {
  // Object.keys(snapData.val()).length
  const db = getDatabase(app);
  const tasksRef = ref(db, "da6d/" + "tasks");
  const countRef = ref(db, "da6d/" + "count");
  const [loading, setLoading] = useState(true);
  const [compeleteCount, setCompeleteCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [progress, setProgress] = useState(50);
  return (
    <Drawer
      sx={{
        width: 240,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: 240,
          boxSizing: "border-box",
        },
      }}
      variant="permanent"
      anchor="right"
    >
      <Toolbar />
      {/* <CircularProgressWithLabel value={progress} /> */}
      <Progress sx={{ height: "100%" }} />
      {/* <Divider />
      <Divider /> */}
    </Drawer>
  );
}
